// @flow

import { useState } from 'react';
import styled from 'styled-components';

import RowIcon from '../../common/components/Forms/RowIcon';
import RowContent from '../../common/components/Forms/RowContent';
import Label from '../../common/components/Text/Label';
import ContentText from '../../common/components/Text/ContentText';
import AnimatedRow from '../../common/components/Forms/AnimatedRow';
import clockNoteIcon from '../../assets/svg/icons/clock-note-gray.svg';
import msgEditIcon from '../../assets/svg/icons/msg-edit-gray.svg';

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const RowColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const IconEdit = styled.img`
  width: 14px;
  height: 14px;
  padding: 10px 10px;
  align-self: flex-start;
`;

const IconEditPlaceholder = styled.div`
  width: 14px;
  height: 14px;
  padding: 10px 10px;
  align-self: flex-start;
`;

const PaddedAnimatedRow = styled(AnimatedRow)`
  padding-left: 16px;
  width: 100%;
`;

type Props = {
  note: string,
  delay: number
};

const ViewTimeClockNote = ({ note, delay }: Props) => {
  const [hover, setHover] = useState(false);

  const handleOnMouseEnter = () => {
    setHover(true);
  };

  const handleOnMouseLeave = () => {
    setHover(false);
  };

  return (
    <PaddedAnimatedRow
      borderBottom
      noPaddingHorizontal
      delay={delay}
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}>
      <RowIcon src={clockNoteIcon} />
      <RowContent>
        <IconContainer>
          <RowColumn>
            <Label>Comment</Label>
            <ContentText whiteSpace="pre-line">{note}</ContentText>
          </RowColumn>
          {hover && <IconEdit src={msgEditIcon} />}
          {!hover && <IconEditPlaceholder />}
        </IconContainer>
      </RowContent>
    </PaddedAnimatedRow>
  );
};

export default ViewTimeClockNote;
